export const AuthenticationPath = '/api/authentication'

export type LogonRequestData = {
  accountNumber: number
  password: string
  rememberAccount: boolean
  keepLoggedIn: boolean
  loginViaBioAuth?: boolean
}

type LogonMfaResult =
  | {
      mustCompleteMfaChallenge: false
    }
  | {
      mustCompleteMfaChallenge: true
      mfaSessionId: string
      mfaFactor: 'SMS' | 'EMAIL'
      mfaHint: string
    }

export type LogonResult =
  | {
      isSuccessful: true
    }
  | ({
      isSuccessful: false
      mustChangePassword: boolean
    } & LogonMfaResult)

export type LogonWithMfaRequest = {
  accountNumber: number
  mfaSessionId: string
  mfaFactor: string
  mfaCode: string
  rememberAccount: boolean
  keepLoggedIn: boolean
}

export type LogonWithMfaResult = {
  isSuccessful: boolean
}

/**
 * HTMLString is just an alias to string to inform
 * the developer that the string contains HTML.
 */
type HTMLString = string

type IsLoggedIn = {
  accountNumber: number
  loggedIn: true
}

type IsLoggedOut = {
  accountNumber: null
  loggedIn: false
}

export type IsAuthenticated = (IsLoggedIn | IsLoggedOut) & {
  token: HTMLString
}
